import './assets/vendor/nucleo/css/nucleo.css';
import './assets/scss/argon-dashboard-react.scss';
import 'katex/dist/katex.min.css';

import * as Sentry from '@sentry/browser';
import PropTypes from 'prop-types';
import React from 'react';
import Notifications from 'react-notification-system-redux';
import { connect, Provider } from 'react-redux';
import { HashRouter } from 'react-router-dom';

import Footer from './components/Footers/Footer';
// Routes
import AppRoutes from './routes';
import { history } from './store/configureStore';

class App extends React.Component {
  componentDidCatch(error, errorInfo) {
    if (process.env.NODE_ENV !== 'development') {
      Sentry.withScope((scope) => {
        scope.setExtra(errorInfo);
        Sentry.captureException(error);
      });
    }
  }

  render() {
    const { store } = this.props;

    return (
      <Provider store={store}>
        <HashRouter history={history}>
          <div className="App">
            <div className="wrap">
              <AppRoutes />
            </div>
            <Footer />
          </div>
        </HashRouter>
        <Notifications notifications={this.props.notifications} />
      </Provider>
    );
  }
}

App.propTypes = {
  store: PropTypes.object.isRequired,
};

export default connect((state) => ({ notifications: state.notifications }))(
  App,
);
